import { cellphoneValidation } from '@convenia/helpers'

export default () => ({
  cellphone: {
    type: 'text',
    label: 'Celular',
    placeholder: 'Celular',
    inputmode: 'numeric',
    mask: '(##) #####-####',
    maskedPrint: true,
    validation: { custom: (_, value) => cellphoneValidation(value) },
    validationMsg: 'Número inválido',
    emitPreValidation: true,
  },

  telephone: {
    type: 'text',
    label: 'Telefone Residencial',
    placeholder: 'Telefone Residencial',
    inputmode: 'numeric',
    mask: '(##) ####-####',
    maskedPrint: true,
    validation: 'min:14',
    validationMsg: 'Número inválido',
    emitPreValidation: true,
  },

  email: {
    type: 'text',
    label: 'E-mail Pessoal',
    placeholder: 'E-mail Pessoal',
    validation: { max: 106, email: true },
    emitPreValidation: true,
  },
})
